import React from "react"
import { Itinerary } from "@mallardbay/lib-react-components"

import Divider from "~components/shared/divider"
import PaymentForm from "~components/pages/book/payment-form"
import BookingCoupon from "~components/pages/book/booking-coupon"
import type { QuoteFieldsFragment } from "~graphql/generated/graphql"

interface Props {
    readonly quote: QuoteFieldsFragment
    readonly isWidget?: boolean
}

export default function BookingForm({ quote, isWidget }: Props) {
    return (
        <div>
            <Itinerary
                itinerary={quote.itinerary}
                listing={quote.listing}
                shouldHideListingLink={isWidget}
            />
            <Divider margin />
            <BookingCoupon />
            <Divider margin />
            <PaymentForm quote={quote} />
        </div>
    )
}
